import { useSelector } from 'react-redux';

import { selectServiceLocations } from 'app/pages/order/redux/order-selector';
import { RequestType } from 'app/pages/order/redux/model/order-request';
import { NavigationService } from 'app/services/navigation-service';
import { RequestToExecute } from 'app/components/protected-content-without-completed-requests';
import { fetchAccountInfoActionCreator } from 'app/pages/order/redux/action-creators/fetch-account-info-action-creator';

export const useAccountInfoRequest = (): RequestToExecute => {
    const serviceLocations = useSelector(selectServiceLocations);

    return {
        requestType: RequestType.GET_ACCOUNT_INFORMATION,
        actionToDispatch: fetchAccountInfoActionCreator(),
        redirectTo: () => {
            if (serviceLocations?.length === 0) {
                return NavigationService.ERROR_NO_SERVICE_LOCATION;
            }

            return undefined;
        },
    };
};
